import handleFilter from './handleFilter';
import handleNextPage from './handleNextPage';

/**
 * Attach interactions to every element that matches selector.
 */
$('.news-list').each((_, component) => {
    const $newsItems = $(component).find('.news-list__item').hide();
    const pageSize = Number($(component).attr('data-page-size')) || 3;

    $(component)
        .on('change', '.select', handleFilter(component, $newsItems, pageSize))
        .on('click', '.loader', handleNextPage(component, $newsItems, pageSize));

    $(window).on('load', handleNextPage(component, $newsItems, pageSize));
});



// WEBPACK FOOTER //
// ./src/scripts/components/news-list/index.js